import { Button, Table, TableProps, message } from 'antd'
import dayjs from 'dayjs'
import { memo, useCallback, useEffect, useRef, useState } from 'react'

import StudentAvatar from '~/components/StudentAvatar'
import { getOrder } from '~/services/order'
import { IOrder } from '~/types/order'

import { Container } from './style'

const Index = () => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<IOrder[]>([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)

  const onPageChange = useCallback((cPage: number, cSize: number) => {
    setPage(cPage)
    setSize(cSize)
  }, [])

  const fetchData = useCallback(() => {
    setLoading(true)
    getOrder(page, size)
      .then((res) => {
        setDataSource(res.data?.content || [])
        setTotal(res.data?.total || 0)
      })
      .catch((err) => {
        message.error(err?.message || '请求错误，请稍后再试')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [page, size])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onSearch = useCallback(() => {
    fetchData()
  }, [fetchData])

  const columns = useRef<TableProps<IOrder>['columns']>([
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      fixed: 'left',
    },
    {
      title: '订单号',
      dataIndex: 'transactionOutTradeNo',
      key: 'transactionOutTradeNo',
      width: 200,
      fixed: 'left',
    },
    {
      title: '用户ID',
      dataIndex: 'userId',
      key: 'userId',
      width: 100,
    },
    {
      title: '学生',
      dataIndex: 'student',
      key: 'student',
      width: 160,
      render: (_, record) => <StudentAvatar student={record.student} showName />,
    },
    {
      title: '套餐信息',
      dataIndex: 'package',
      key: 'package',
      width: 240,
      render: (text, record) => {
        return (
          <div>
            <div>套餐ID：{record.package.id}</div>
            <div>套餐名称：{record.package.name}</div>
            <div>套餐有效期：{record.package.validityDescription}</div>
            <div>套餐价格：{record.package.priceAfterDiscount}</div>
          </div>
        )
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
    },
    {
      title: '价格',
      dataIndex: 'transactionAmountTotal',
      key: 'transactionAmountTotal',
      width: 150,
      render: (text) => `¥ ${(text / 100).toFixed(2)}`,
    },
    {
      title: '货币类型',
      dataIndex: 'transactionAmountCurrency',
      key: 'transactionAmountCurrency',
      width: 150,
    },
    {
      title: 'openId',
      dataIndex: 'transactionPayerOpenId',
      key: 'transactionPayerOpenId',
      width: 280,
    },
    {
      title: 'transactionId',
      dataIndex: 'transactionId',
      key: 'transactionId',
      width: 280,
    },

    {
      title: '失败原因',
      dataIndex: 'failureReason',
      key: 'failureReason',
      width: 150,
    },
    {
      title: '更新时间',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
  ])

  return (
    <Container>
      <div className="top">
        <Button
          style={{ marginRight: 12 }}
          type="primary"
          loading={loading}
          onClick={onSearch}
        >
          查询
        </Button>
      </div>
      <div className="table">
        <Table
          rowKey="id"
          scroll={{ y: 500 }}
          loading={loading}
          columns={columns.current}
          dataSource={dataSource}
          pagination={{
            total,
            pageSize: size,
            current: page,
            onChange: onPageChange,
          }}
        />
      </div>
      <div className="pagination"></div>
    </Container>
  )
}

export default memo(Index)
